import { FileType } from '@office-start/document-types';
export function getStartPageApplications(_a) {
    var _b, _c, _d, _e, _f, _g;
    var isCommercialUser = _a.isCommercialUser, featureGates = _a.featureGates, commercialStartPageApps = _a.commercialStartPageApps, consumerStartPageApps = _a.consumerStartPageApps;
    var startPageApps = (isCommercialUser ? commercialStartPageApps : consumerStartPageApps).split(',');
    if (isCommercialUser) {
        var isVisioEnabled = (_c = (_b = featureGates.wacStartPageConfigGates) === null || _b === void 0 ? void 0 : _b.wacStartPageConfigVisioStartPageEnabled) !== null && _c !== void 0 ? _c : false;
        var isWhiteboardEnabled = (_e = (_d = featureGates.modernWhiteboardStartGates) === null || _d === void 0 ? void 0 : _d.modernWhiteboardStartEnabled) !== null && _e !== void 0 ? _e : false;
        var isClipchampEnabled = (_g = (_f = featureGates.modernClipChampStartGates) === null || _f === void 0 ? void 0 : _f.modernClipChampStartEnabled) !== null && _g !== void 0 ? _g : false;
        if (isVisioEnabled &&
            !startPageApps.includes(FileType.Visio.toLowerCase())) {
            startPageApps.push(FileType.Visio.toLowerCase());
        }
        if (isWhiteboardEnabled &&
            !startPageApps.includes(FileType.Whiteboard.toLowerCase())) {
            startPageApps.push(FileType.Whiteboard.toLowerCase());
        }
        if (isClipchampEnabled &&
            !startPageApps.includes(FileType.Clipchamp.toLowerCase())) {
            startPageApps.push(FileType.Clipchamp.toLowerCase());
        }
    }
    return startPageApps;
}
//# sourceMappingURL=getStartPageApplications.js.map